import { SearchInput } from "@/shared/components";
import * as React from "react";

export interface GlobalFilter<T extends Record<string, unknown>> {
    columns: (keyof T)[];
    placeholder: string;
}

interface DataTableGlobalFilterProps {
    globalFilter: string;
    setGlobalFilter: React.Dispatch<React.SetStateAction<string>>;
    placeholder?: string;
}

export function DataTableGlobalFilter({ globalFilter, setGlobalFilter, placeholder }: Readonly<DataTableGlobalFilterProps>) {
    return <SearchInput search={globalFilter} setSearch={setGlobalFilter} placeholder={placeholder} />;
}
